// A token resolves per user, so it can't name a stored attribute or value.
const TEMPLATE_TOKEN = /\{\{[^}]*\}\}/g;

/**
 * Converts a label string to a valid data identifier.
 * - Converts to lowercase
 * - Replaces spaces with underscores
 * - Removes non-alphanumeric characters (except underscores and hyphens)
 * - Removes leading/trailing underscores
 * - Collapses multiple consecutive underscores
 *
 * @example
 * labelToIdentifier("What's your favorite color?") // "whats_your_favorite_color"
 * labelToIdentifier("Your question") // "your_question"
 */
export const labelToIdentifier = (label: string): string => {
  return label
    .toLowerCase()
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-z0-9_-]/g, '') // Remove non-alphanumeric chars (keep underscores and hyphens)
    .replace(/_+/g, '_') // Collapse multiple underscores
    .replace(/^_|_$/g, ''); // Remove leading/trailing underscores
};

export const templateToIdentifier = (text: string): string => labelToIdentifier(text.replace(TEMPLATE_TOKEN, ' '));

/**
 * A button's saved value from its label: the first word ("Yes, it's correct" gives `yes`), else the
 * whole label, else a numbered one, whichever no other button holds yet.
 */
export const suggestButtonValue = (label: string, taken: ReadonlySet<string>): string => {
  const slug = templateToIdentifier(label);
  if (!slug) return '';
  const firstWord = slug.split('_')[0] ?? slug;
  if (!taken.has(firstWord)) return firstWord;
  if (!taken.has(slug)) return slug;
  let n = 2;
  while (taken.has(`${slug}_${n}`)) n += 1;
  return `${slug}_${n}`;
};
